import React from 'react';
import styled from 'astroturf/react';

import { VideoProcessingStatus } from '../shared/video_helper';

interface Props {
  processingStatus: VideoProcessingStatus;
  /**
   * Controls how the component renders
   * 'feed' - uses 3:2 aspect ratio (for social feed)
   * 'page' - uses fixed height (for dedicated video pages)
   */
  context?: 'feed' | 'page';
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  background-color: #e2e2e2;
  color: #555555;
`;

const Message = styled.h2`
  font-size: 20px;

  @media screen and (min-width: 630px) {
    font-size: 28px;
  }
`;

const Icon = styled.i`
  font-size: 50px;
  font-weight: 300;
  line-height: 50px;
  text-align: center;
`;

export default function VideoUnavailable(props: Props) {
  const { processingStatus, context = 'page' } = props;

  let message;
  let icon;
  if (processingStatus === 'processing_failed') {
    message = 'Sorry, this video is unavailable.';
    icon = <Icon className="fa fa-exclamation-triangle" />;
  } else {
    message = 'Video processing, please check back shortly.';
    icon = <Icon className="fa fa-spinner fa-spin" />;
  }

  const containerStyle =
    context === 'page' ? { height: '600px' } : { aspectRatio: '3/2' };

  return (
    <Container style={containerStyle}>
      {icon}
      <Message>{message}</Message>
    </Container>
  );
}
